import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BillingService } from '../../../../services/billing.service';
import { Subscription } from 'rxjs';
import { saveAs } from 'file-saver/FileSaver';
import { MatSnackBar } from '@angular/material';
import { TransactionList } from '../../../../models/transaction.model';
import { WMSValidators } from '../../../../shared/validators';

@Component({
    selector: 'dialog-sarawak-government-export-transaction',
    templateUrl: 'dialog.exporttransaction.html',
    styleUrls: ['dialog.exporttransaction.css']
})
export class ExportSarawakGovernmentTransactionDialog implements OnInit, OnDestroy {
    allSub: Subscription[] = [];
    disabledSend: boolean = false;
    isModifiedBookingDate: boolean = false;
    saveFileToLocal: boolean = false;
    errorMessage: string = '';
    dueDate: Date = new Date();
    reportDate: Date = new Date();
    totalAmount: string = '0.00';
    modifiedBookingDate: Date = new Date();
    swk_Transaction: TransactionList;

    mailtoform: FormGroup;
    mailccform: FormGroup;
    mailbccform: FormGroup;
    emailSubject: string = '';
    emailMessage: string = '';
    mailList = [];
    mailToList = [];
    mailCCList = [];
    mailBCCList = [];

    //Download message
    downloadMessage: string = '';

    constructor(public dialogRef: MatDialogRef<ExportSarawakGovernmentTransactionDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private billingService: BillingService,
        public snackBar: MatSnackBar) { }

    ngOnInit() {
        this.mailtoform = new FormGroup({
            mailTo: new FormControl({ value: '', disabled: false }, [WMSValidators.email, Validators.maxLength(50)])
        });

        this.mailccform = new FormGroup({
            mailCC: new FormControl({ value: '', disabled: false }, [WMSValidators.email, Validators.maxLength(50)])
        });

        this.mailbccform = new FormGroup({
            mailBCC: new FormControl({ value: '', disabled: false }, [WMSValidators.email, Validators.maxLength(50)])
        });

        this.swk_Transaction = {
            agentCode: this.data.agentCode,
            accOffCode: this.data.accOffCode,
            warrantNumber: this.data.warrantNo,
            recordStatus: this.data.recordStatus,
            paymentFrom: this.data.paymentFrom,
            paymentTo: this.data.paymentTo,
            sqlPNR: this.data.sqlPNR,
            invoiceNo: this.data.invoiceNo,
            pukalNo: null,
            travelAgent: null,
            page: null,
            isSplitBooking: null,
            PageSize: null,
            transactionType: null
        }

        let getAccOffSub = this.billingService.getInitExportSwkTransactions(this.swk_Transaction)
            .subscribe(
                (value) => {
                    this.mailList = value.body['accOffList'];

                    this.mailList.forEach((item) => {
                        if (item['Mail_To'].length > 0) {
                            this.mailToList.push(item['Mail_To']);
                        };

                        if (item['Mail_CC'].length > 0) {
                            this.mailCCList.push(item['Mail_CC']);
                        };

                        if (item['Mail_BCC'].length > 0) {
                            this.mailBCCList.push(item['Mail_BCC']);
                        };
                    });

                    if (typeof (value.body['totalAmount']) === 'string' && value.body['totalAmount'] !== '0.00') {
                        this.totalAmount = value.body['totalAmount'];
                    } else {
                        this.totalAmount = '0.00';

                        this.disabledSend = true; //disabled download button & show message
                        this.downloadMessage = 'Transaction record is empty.';
                    }
                },
                (error) => {
                    this.errorMessage = <any>error;
                    this.openSnackBar(this.errorMessage, '');
                });

        //Adds into array for each subscribe
        this.allSub.push(getAccOffSub);
    }

    addMailTo() {
        if (this.mailtoform.get('mailTo')!.value.length > 0) {
            this.mailToList.push(this.mailtoform.get('mailTo')!.value);

            this.mailtoform.setValue({
                mailTo: ''
            });
        } else {
            this.openSnackBar('Invalid Email.', '');
        }
    }

    addMailCC() {
        if (this.mailccform.get('mailCC')!.value.length > 0) {
            this.mailCCList.push(this.mailccform.get('mailCC')!.value);

            this.mailccform.setValue({
                mailCC: ''
            });
        } else {
            this.openSnackBar('Invalid Email.', '');
        }
    }

    addMailBCC() {
        if (this.mailbccform.get('mailBCC')!.value.length > 0) {
            this.mailBCCList.push(this.mailbccform.get('mailBCC')!.value);

            this.mailbccform.setValue({
                mailBCC: ''
            });
        } else {
            this.openSnackBar('Invalid Email.', '');
        }
    }

    cbModifiedBookingDate(e): void {
        this.isModifiedBookingDate = e.checked;
    }

    cbsaveFileToLocalOnChange(e): void {
        this.saveFileToLocal = e.checked;
    }

    sendOnClick() {
        let cfm = confirm("Are you sure you want to download the PTJ Billing Files?");

        if (cfm) {
            this.downloadMessage = 'System is processing the PTJ Billing Files....';
            this.disabledSend = true;

            this.swk_Transaction.agentCode = this.data.agentCode;
            this.swk_Transaction.paymentFrom = this.data.paymentFrom;
            this.swk_Transaction.paymentTo = this.data.paymentTo;
            this.swk_Transaction.sqlPNR = this.data.sqlPNR;
            this.swk_Transaction.accOffCode = this.data.accOffCode;
            this.swk_Transaction.warrantNumber = this.data.warrantNo;
            this.swk_Transaction.recordStatus = this.data.recordStatus;

            let download = {
                SwkTransaction: this.swk_Transaction,
                DueDate: this.dueDate,
                ReportDate: this.reportDate,
                IsModifiedBookingDate: this.isModifiedBookingDate,
                ModifiedBookingDate: this.modifiedBookingDate,
                EmailSubject: this.emailSubject,
                EmailMessage: this.emailMessage,
                MailToList: this.mailToList,
                MailCcList: this.mailCCList,
                MailBccList: this.mailBCCList,
                SaveFileToLocal: this.saveFileToLocal
            };

            let exportTransSub = this.billingService.downloadSwkBilling(download)
                .subscribe(
                    (value) => {
                        if (value.status === 204) {
                            this.disabledSend = false;
                            this.downloadMessage = '';
                            this.openSnackBar('Send failed.', '');
                        } else if (value.status === 200 && download.SaveFileToLocal) {
                            let blob = new Blob([value.body], { type: 'application/zip' });
                            saveAs(blob, 'PTJ Billing.zip');

                            this.disabledSend = false;
                            this.downloadMessage = '';
                            this.dialogRef.close('File Created.');
                        } else if (value.status === 200 && !download.SaveFileToLocal) {
                            this.disabledSend = false;
                            this.downloadMessage = '';
                            this.dialogRef.close('Send successful.');
                        } else {
                            this.disabledSend = false;
                            this.downloadMessage = '';
                            this.openSnackBar('Send failed.', '');
                        }
                    },
                    (error) => {
                        this.errorMessage = <any>error;
                        this.openSnackBar(this.errorMessage, '');
                    });

            //Adds into array for each subscribe
            this.allSub.push(exportTransSub);
        } else {
            this.downloadMessage = '';
            this.disabledSend = false;
        }
    }

    ngOnDestroy() {
        for (let sub of this.allSub) {
            sub.unsubscribe();
        }
    }

    openSnackBar(message: string, action: string) {
        this.snackBar.open(message, action, {
            duration: 3000,
        });
    }
}
